(function($){

    $('body').on('click', '#token', function(){
        legia_sso_login($('#token').html());
    });
    if($('.sso-logout').length > 0){
        localStorage.removeItem('user');
        window.location.href = $('.sso-logout').attr('data-home');
    }
    function legia_sso_login(token){
        var userData = decodeURIComponent(token);
        localStorage.setItem('user', userData);
        var user = localStorage.getItem('user');
        var decrypted = CryptoJS.AES.decrypt(user, 'secret');
        var plaintext = decrypted.toString(CryptoJS.enc.Utf8);
        var ssodata = JSON.parse(plaintext);
        $.ajax({
            url: script.ajax_url,
            method: 'post',
            data: {
                'action': 'legia_sso_login',
                'ssodata': ssodata,
                'nonce': script.nonce
            },
            // beforeSend: function(){
            //     $('.wp-block-search__button-inside').append('<img src="'+$('body').attr('data-loader')+'" class="sso-loader" />');
            // },
            success: function (data) {
                try{
                    var resp = JSON.parse(data);
                    if(resp['state'] == 'success'){
                        window.location.href = resp['redirectUri'];
                    }
                    else{

                    }
                }
                catch(e){
                    alert();
                }
            },
            error: function (errorThrown) {
                console.log(errorThrown);
            }
        });
    }

})(jQuery)